import React, { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { MultiFormObjType } from "DataTypes/Form";
import { CommonStyle, ControlledForm, ControlledTable } from "Components";
import {
  actionArr,
  FormDataObj,
  PreApprovTableDataType,
  TableCol,
  TableData
} from "./Data";
import CommonFormatter from "Utils/Common.Formatter";
import { RouteUrls } from "Constant/RouteUrls";
import { TableLayout } from "Layouts";
import CstmBtn from "Components/CstmBtn";
import { useLocation, useNavigate } from "react-router-dom";

const PreApprovedPlan: FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const fullName = `${state?.firstName} ${state?.lastName}`
  const [formObj, setFormObj] = useState<MultiFormObjType>(FormDataObj);

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "upload patient",
      label: `${fullName}'s Pre Approved Plans`,
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${RouteUrls.preApprovedPlan}`,
      level: 2,
      link: RouteUrls.preApprovedPlan,
      navType: "org",
    });
  }, []);

  const handleEditPreApprovedPlan: (
    data: PreApprovTableDataType
  ) => void = (data) => {
    navigate(`./${data.id}/${RouteUrls.plan}`);
  }

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol()}
      tableRow={TableData}
      tableAction={(data: PreApprovTableDataType) =>
        actionArr(
          () => handleEditPreApprovedPlan(data),
          data
        )
      }
    />
  );

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Box display="flex" mb={2} alignItems={"end"}>
          <Box width="30%" mr={2}>
            <ControlledForm.MultiApi
              {...formObj}
              onClick={async (val) => setFormObj({ ...formObj, dropVal: val })}
            />
          </Box>
          <CstmBtn
            label="Send Approval Request"
            onClick={() => console.log("test")} />
        </Box>
        <TableLayout
          tblBody={TblBodyJSX}
          tblHead={ControlledTable.TblHead(TableCol())}
        />
      </Box>
    </Box>
  );
};
export default PreApprovedPlan;
